import React, { useState, useEffect } from "react";
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  Button,
  List,
  ListItem,
  Card,
  CardMedia,
  CardContent,
  Divider,
  Chip,
  TextField,
  Paper,
  CircularProgress,
  Modal,
  FormControl,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import {
  Close,
  Add,
  Remove,
  Delete,
  ShoppingCart,
  LocalShipping,
  ShoppingBag,
  DeliveryDining,
  TakeoutDining,
  HideImage,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useNotification } from "../../contexts/NotificationContext";
import { useRestaurant } from "../../contexts/RestaurantContext";
import { restaurantService } from "../../services/restaurantService";
import { getImageProps } from "../../utils/imageUtils";
import { CartItemSkeleton } from "../common/SkeletonLoader";
import outletService from "../../services/outletService";
import colors from './../../components/colors'

const Modalstyle = {
  textAlign: "center",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const CartDrawer = ({
  open,
  onClose,
  cart: propCart,
  onUpdateQuantity,
  onRemoveItem,
  onCheckout,
  actualServiceType,
  setActualServiceType,
  loading = false,
  checkoutButtonText = "Checkout",
  checkoutButtonIcon = <LocalShipping />,
}) => {
  const navigate = useNavigate();
  const {
    cart: contextCart,
    updateCartItem,
    removeFromCart,
    clearCart,
    getCartTotal,
    getCartItemCount,
    restaurant,
    selectedOutlet,
    taxInfo,
  } = useRestaurant();

  // console.log("Selected Outlet in Drawer => ", selectedOutlet);

  // Use prop cart if provided, otherwise use context cart
  const cart = contextCart;
  // console.log("Cart in Drawer =>", cart)

  if (localStorage.getItem("cart_items") && cart == []) {
    // console.log("Yes It is Time");
  }
  const [taxDetails, setTaxDetails] = useState({
    gst: "",
    delivery_fee: "",
    service_charge: "",
    free_delivery: "",
  });

  // console.log("tax info => ", taxInfo);
  const [cartItems, setCartItems] = useState([])
  const [modalOpen, setModalOpen] = useState(false);
  const [preference, setPreference] = useState("");
  const { showSuccess, showError } = useNotification();
  const [cartItemsTotal, setCartItemsTotal] = useState(0);
  const [cartTax,setCartTax] = useState(0)
  const [cartFinalTotal,setCartFinalTotal] = useState(0)
  const cartTotal = getCartTotal ? getCartTotal() : 0;
  const cartItemCount = getCartItemCount ? getCartItemCount() : 0;
  const deliveryFee = taxInfo?.delivery_fee ? taxInfo.delivery_fee : 0;
  let taxes = taxInfo.gst;

  // const taxes = taxInfo?.gst;
  let finalTotal = cartItemsTotal;
  if (cartTotal < taxInfo?.free_delivery && preference === "delivery" && !taxInfo?.lalamove) {
    // console.log(cartTotal + " > " + taxInfo.free_delivery);
    finalTotal += deliveryFee;
  }

  if (taxInfo?.free_delivery === 0 && preference === "delivery" && !taxInfo?.lalamove) {
    finalTotal += deliveryFee;
  }

  let taxValue = cartItemsTotal * taxes;
  finalTotal += taxValue;
  taxes = taxValue;

  // console.log("Preference is => ", preference);
  // console.log("cart => ", cart);
  // console.log("Delivery Fee =>", deliveryFee);
  // console.log("CArt Total => ", cartTotal);
  // console.log("Final Cost ", finalTotal);
  async function fetchCartItems() {
    try {
      const response = await restaurantService.getCartItems(localStorage.getItem('cart_id'));
      setCartItems(response.cart_items)
      if(taxInfo?.inclusive){
        const new_subtotal = response.cart_total / (1 + taxInfo?.gst);
        // console.log("New Subtotal => ",new_subtotal)
        const new_tax = response.cart_total - new_subtotal ;
        taxes= new_tax
        // console.log("New New Tax => ",new_tax)
        setCartItemsTotal(new_subtotal)
        setCartTax(new_tax)
        let new_cart_total = new_subtotal + new_tax;
        if (preference === 'delivery') {
          new_cart_total += deliveryFee
        }
        console.log("Cart Final Total => ", new_cart_total)
        setCartFinalTotal(new_cart_total)
      }
      else{
        setCartItemsTotal(response.cart_total)
      }
      
    }
    catch (error) {
      console.error("Error on Getting Cart Items", error)
    }
  }
  useEffect(() => {
    // console.log("Yes Here in Cart Drawer")
    fetchCartItems();
  }, [open,preference])

  useEffect(() => {
    if (open) {
      // Store the current scroll position
      const scrollY = window.scrollY;
      const body = document.body;

      // Disable scroll
      body.style.position = 'fixed';
      body.style.top = `-${scrollY}px`;
      body.style.width = '100%';
      body.style.overflow = 'hidden';

      return () => {
        // Re-enable scroll when drawer closes
        body.style.position = '';
        body.style.top = '';
        body.style.width = '';
        body.style.overflow = '';
        window.scrollTo(0, scrollY);
      };
    }
  }, [open]);


  // console.log("Cart Items from Backend => ", cartItems)

  const handleQuantityChange = async (cartItemId, sizeName, newQuantity, addons) => {
    // console.log("At cart drawer =>", cartItemId, " -> ", sizeName, " => ", addons);

    if (onUpdateQuantity) {
      onUpdateQuantity(cartItemId, newQuantity);
    } else if (newQuantity <= 0) {
      removeFromCart && removeFromCart(cartItemId, sizeName, addons);
    } else {

      updateCartItem && updateCartItem(cartItemId, sizeName, { quantity: newQuantity }, addons);
    }
    setTimeout(() => {
      fetchCartItems();
    }, 300);
  };

  const handleRemoveItem = (cartItemId, sizeName, addons) => {
    removeFromCart && removeFromCart(cartItemId, sizeName, addons);

    setTimeout(() => {
      fetchCartItems();
    }, 300);
  };

  const handleProccedToCheckout = () => {
    // console.log("At Handle Proceed to Checkout");
    if (preference === "") {
      showError("Please Click the any one of the Preference to Continue");
      return;
    }
    setActualServiceType(preference);
    if (sessionStorage.getItem("user")) {
      // console.log("user available");
      navigate("/checkout", { state: { orderType: preference } });
    } else {
      localStorage.setItem("preference", preference);
      onCheckout("guest-signup", preference);
    }
    onClose();
  };

  const handleCheckout = (serviceType) => {
    if (onCheckout) {
      onCheckout(serviceType);
    } else {
      onClose();
      if (serviceType === "guest-signup") {
        navigate("/guest-signup", { state: { taxDetails: taxDetails } });
      } else {
        navigate("/checkout", {
          state: { orderType: serviceType, taxDetails: taxDetails },
        });
      }
    }
  };



  // console.log("tax details => ", deliveryFee);

  if (!cart || cart.length === 0) {
    return (
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 3,
          "& .MuiDrawer-paper": {
            width: {
              xs: "80vw", // Full width on extra small screens
              sm: 380,
              md: 400,
              lg: 420,
              xl: 440, // Added for extra large screens
            },
            maxWidth: "100vw", // Ensure it doesn't exceed viewport
            boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
            borderRadius: 0,
            display: "flex",
          },
        }}
      >
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            p: { xs: 1.5, sm: 2, md: 3 }, // Responsive padding
            position: "relative",
          }}
        >
          <IconButton
            onClick={onClose}
            sx={{
              position: "absolute",
              top: { xs: 4, sm: 8, md: 12 }, // Responsive positioning
              right: { xs: 4, sm: 8, md: 12 },
              size: { xs: "small", sm: "medium" },
            }}
          >
            <Close
              sx={{
                fontSize: {
                  xs: "1.1rem !important",
                  sm: "1.3rem !important",
                  md: "1.5rem !important",
                  lg: "1.6rem !important",
                },
              }}
            />
          </IconButton>

          <ShoppingCart
            sx={{
              fontSize: {
                xs: 45,
                sm: 55,
                md: "48px !important",
                lg: "52px !important",
              },
              color: colors.primary.main,
              mt: { xs: 1, sm: 2, md: 3 },
              mb: { xs: 0.5, sm: 1, md: 1.5 },
            }}
          />

          <Typography
            variant="h6"
            gutterBottom
            sx={{
              fontSize: {
                xs: "0.95rem !important",
                sm: "1.05rem !important",
                md: "20px !important",
                lg: "22px !important",
              },
              fontWeight: "600 !important",
              px: { xs: 1, sm: 0 }, // Add horizontal padding on small screens
            }}
          >
            Your cart is empty
          </Typography>

          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              mb: { xs: 1.5, sm: 2, md: 2.5 },
              fontSize: {
                xs: "0.8rem !important",
                sm: "0.85rem !important",
                md: "16px !important",
                lg: "17px !important",
              },
              px: { xs: 1, sm: 0 }, // Add horizontal padding on small screens
            }}
          >
            Add some delicious items to get started
          </Typography>

          <Button
            variant="contained"
            onClick={() => {
              onClose();
              navigate("/delivery");
            }}
            sx={{
              borderRadius: "8px",
              backgroundColor: colors.primary.main,
              color: "white",
              fontSize: {
                xs: "0.8rem !important",
                sm: "0.85rem !important",
                md: "16px !important",
                lg: "17px !important",
              },
              py: { xs: 0.6, sm: 0.8, md: 1, lg: 1.1 },
              px: { xs: 1.5, sm: 2.5, md: 3, lg: 3.5 },
              minWidth: { xs: "120px", sm: "140px" }, // Ensure proper button width
              "&:hover": {
                backgroundColor: colors.secondary.main,
              },
            }}
          >
            Browse Products
          </Button>
        </Box>
      </Drawer>
    );
  }

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: { xs: "95vw", sm: 380, md: 400, lg: 420 },
          boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
          borderRadius: 0,
        },
      }}
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 3 }}
    >
      <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
        {/* Header */}
        <Box
          sx={{
            p: { xs: 1.5, sm: 2 },
            borderBottom: "1px solid",
            borderColor: "divider",
            overflow: 'visible !important'
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 1,
            }}
          >
            <Typography
              sx={{
                fontSize: {
                  xs: "1rem !important",
                  sm: "1.1rem !important",
                  md: "1.25rem !important",
                },
                fontWeight: "600 !important",
                color: "#1A1A1A",
              }}
            >
              Your Order Details
            </Typography>
            <IconButton onClick={onClose} size="small">
              <Close
                sx={{
                  fontSize: {
                    xs: "1.2rem !important",
                    sm: "1.4rem !important",
                    md: "1.5rem !important",
                  },
                }}
              />
            </IconButton>
          </Box>
          <Typography
            sx={{
              fontSize: {
                xs: "0.9rem !important",
                sm: "1rem !important",
                md: "1.1rem !important",
              },
              fontWeight: "600 !important",
              color: colors.primary.main,
            }}
          >
            {selectedOutlet?.name}
          </Typography>
          <Typography
            variant="body2"
            color="#444444"
            sx={{
              fontSize: {
                xs: "0.75rem !important",
                sm: "0.8rem !important",
                md: "0.875rem !important",
              },
              mt: 0.5,
              fontWeight: "400 !important",
            }}
          >
            {selectedOutlet?.address}
          </Typography>
        </Box>

        <Box sx={{ flexGrow: 1, overflow: "auto" }}>
          <Box sx={{ p: { xs: 1, sm: 1.5 } }}>
            {(cartItems || []).map((item) => (
              <Card
                key={item.id}
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: "stretch",
                  p: { xs: 1, sm: 1.5 },
                  boxShadow: "0px 2px 6px rgba(0,0,0,0.08)",
                  borderRadius: 2,
                  mb: { xs: 1, sm: 1.5 },
                }}
              >
                {/* --- Content --- */}
                <Box
                  sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    ml: { sm: 1.5, md: 2 },
                    mt: { xs: 1, sm: 0 },
                  }}
                >
                  {/* --- Title, Description, and Delete --- */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Box sx={{ flex: 1, mr: 1 }}>
                      <Typography
                        sx={{
                          fontWeight: "600 !important",
                          color: colors.primary.main,
                          fontSize: {
                            xs: "0.9rem !important",
                            sm: "1rem !important",
                            md: "1.1rem !important",
                          },
                        }}
                      >
                        {item?.name || "Menu Item"} - S$ {(item?.price || item?.discount_price || item?.base_price || 0).toFixed(2)}
                      </Typography>


                      {item?.selectedSize &&
                        <Typography
                          sx={{
                            fontSize: {
                              xs: "0.8rem !important",
                              sm: "0.85rem !important",
                              md: "0.9rem !important",
                            },
                            textAlign: "left",
                            color: "#1A1A1A",
                            fontWeight: "600 !important",
                            mt: 0.5,
                          }}
                        >
                          Size : <span style={{ color: 'white', backgroundColor: 'green', padding: 2, borderRadius: '6px', fontSize: '10px' }}>{item?.selectedSize?.name}</span>
                        </Typography>}


                      {item?.discount_percentage > 0 &&
                        <Typography
                          sx={{
                            fontSize: {
                              xs: "0.8rem !important",
                              sm: "0.85rem !important",
                              md: "0.9rem !important",
                            },
                            textAlign: "left",
                            color: "#1A1A1A",
                            fontWeight: "600 !important",
                            mt: 0.5,
                          }}
                        >
                          <span style={{ color: 'white', backgroundColor: '#D32f2f', padding: 2, borderRadius: '6px', fontSize: '10px' }}>{item?.discount_percentage} % Off</span>
                        </Typography>}

                      {/* <Typography
                        sx={{
                          fontSize: {
                            xs: "0.8rem !important",
                            sm: "0.85rem !important",
                            md: "0.9rem !important",
                          },
                          textAlign: "left",
                          color: "#1A1A1A",
                          fontWeight: "600 !important",
                          mt: 0.5,
                        }}
                      >
                        S$ {(item?.discount_price || item?.price || item?.base_price || 0).toFixed(2)}
                      </Typography> */}
                      {item.addons.length > 0 && (
                        <ul>
                          {item.addons.map((addon, index) => (
                            <li key={index}>
                              <Typography component="span" sx={{ fontWeight: 600 }}>{addon?.name} - S${addon?.price}</Typography>
                            </li>
                          ))}
                        </ul>
                      )}
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          mt: 1,
                        }}
                      >

                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            bgcolor: colors.primary.main,
                            borderRadius: 1,
                            overflow: "hidden",
                          }}
                        >
                          <IconButton
                            size="small"
                            onClick={() =>
                              handleQuantityChange(
                                item.id,
                                item.selectedSize ? item.selectedSize.name : null,
                                (item.quantity || 1) - 1,
                                item.addons
                              )
                            }
                            sx={{
                              color: "#fff",
                              px: { xs: 0.5, sm: 1 },
                            }}
                          >
                            <Remove
                              sx={{
                                fontSize: {
                                  xs: "1rem !important",
                                  sm: "1.1rem !important",
                                },
                              }}
                            />
                          </IconButton>
                          <Typography
                            sx={{
                              color: "#fff",
                              fontWeight: "600 !important",
                              fontSize: {
                                xs: "0.8rem !important",
                                sm: "0.9rem !important",
                              },
                              px: { xs: 0.5, sm: 1 },
                              minWidth: { xs: 30, sm: 36 },
                              textAlign: "center",
                            }}
                          >
                            {item.quantity || 1}
                          </Typography>
                          <IconButton
                            size="small"
                            onClick={() =>
                              handleQuantityChange(
                                item.id,
                                item.selectedSize ? item.selectedSize.name : null,
                                (item.quantity || 1) + 1,
                                item.addons,
                              )
                            }
                            sx={{
                              color: "#fff",
                              px: { xs: 0.5, sm: 1 },
                            }}
                          >
                            <Add
                              sx={{
                                fontSize: {
                                  xs: "1rem !important",
                                  sm: "1.1rem !important",
                                },
                              }}
                            />
                          </IconButton>
                        </Box>
                      </Box>

                      <IconButton
                        color="error"
                        size="small"
                        onClick={() => handleRemoveItem(item.id, item.selectedSize?.name, item.addons)}
                        sx={{ flexShrink: 0 }}
                      >
                        <Delete fontSize="small" />
                      </IconButton>
                    </Box>
                  </Box>

                  {/* --- Edit and Quantity Controls --- */}
                </Box>
              </Card>
            ))}
          </Box>
        </Box>

        <Box
          sx={{
            p: { xs: 1.5, sm: 2 },
            borderTop: "1px solid",
            borderColor: "divider",
            marginBottom: 5,
          }}
        >
          <Typography
            sx={{
              fontSize: {
                xs: "1rem !important",
                sm: "1.1rem !important",
                md: "1.25rem !important",
              },
              textAlign: "left",
              color: "#1A1A1A",
              fontWeight: "600 !important",
              mt: 1,
              mb: 1,
            }}
          >
            Order Summary
          </Typography>

          <Box
            sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}
          >
            <Typography
              sx={{
                fontSize: {
                  xs: "0.875rem !important",
                  sm: "0.9rem !important",
                  md: "1rem !important",
                },
                textAlign: "left",
                color: "#1A1A1A",
                fontWeight: "500 !important",
                mt: 0.5,
                mb: 1,
              }}
            >
              Subtotal
            </Typography>
            <Typography
              sx={{
                fontSize: {
                  xs: "0.875rem !important",
                  sm: "0.9rem !important",
                  md: "1rem !important",
                },
                color: "#1A1A1A",
                fontWeight: "600 !important",
                mt: 0.5,
                mb: 1,
              }}
            >
              S${cartItemsTotal.toFixed(2)}
            </Typography>
          </Box>

          {(() => {
            const totalSavings = cart.reduce((sum, item) => {
              if (item.discount_enabled && item.discount_percentage > 0) {
                const originalTotal = item.original_price * item.quantity;
                const discountedTotal = item.discounted_price * item.quantity;
                return sum + (originalTotal - discountedTotal);
              }
              return sum;
            }, 0);

            return totalSavings > 0 ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mb: 0.5,
                }}
              >
                <Typography
                  variant="body2"
                  color="success.main"
                  sx={{
                    fontSize: {
                      xs: "0.75rem !important",
                      sm: "0.8rem !important",
                      md: "0.875rem !important",
                    },
                  }}
                >
                  Discount Savings
                </Typography>
                <Typography
                  variant="body2"
                  color="success.main"
                  fontWeight="600"
                  sx={{
                    fontSize: {
                      xs: "0.75rem !important",
                      sm: "0.8rem !important",
                      md: "0.875rem !important",
                    },
                  }}
                >
                  -${totalSavings.toFixed(2)}
                </Typography>
              </Box>
            ) : null;
          })()}

          {preference === "delivery" && (
            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
              <Typography
                sx={{
                  fontSize: {
                    xs: "0.875rem !important",
                    sm: "0.9rem !important",
                    md: "1rem !important",
                  },
                  textAlign: "left",
                  color: "#1A1A1A",
                  fontWeight: "500 !important",
                  mb: 1,
                }}
              >
                Delivery Fee
              </Typography>
              <Typography
                sx={{
                  fontSize: {
                    xs: "0.875rem !important",
                    sm: "0.9rem !important",
                    md: "1rem !important",
                  },
                  color: "#1A1A1A",
                  fontWeight: "600 !important",
                  mb: 1,
                }}
              >
                {taxInfo?.lalamove ? (
                  // Only show lalamove message if NOT eligible for free delivery
                  (cartTotal >= taxInfo.free_delivery) ? (
                    "FREE"
                  ) : (
                    "Delivery fee is based on delivery address"
                  )
                ) : deliveryFee === 0 ||
                  (taxInfo.free_delivery != 0 && cartTotal >= taxInfo.free_delivery) ? (
                  "FREE"
                ) : (
                  `S$${deliveryFee.toFixed(2)}`
                )}
              </Typography>
            </Box>
          )}

          {taxInfo?.gst > 0 && (
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}
            >
              <Typography
                sx={{
                  fontSize: {
                    xs: "0.875rem !important",
                    sm: "0.9rem !important",
                    md: "1rem !important",
                  },
                  textAlign: "left",
                  color: "#1A1A1A",
                  fontWeight: "500 !important",
                  mb: 1,
                }}
              >
                Taxes & Charges
              </Typography>
              <Typography
                sx={{
                  fontSize: {
                    xs: "0.875rem !important",
                    sm: "0.9rem !important",
                    md: "1rem !important",
                  },
                  color: "#1A1A1A",
                  fontWeight: "600 !important",
                  mb: 1,
                }}
              >
                 {taxInfo?.inclusive ? `S${cartTax.toFixed(2)}` : `S${taxes.toFixed(2)}`} 
              </Typography>
            </Box>
          )}

          <Divider sx={{ my: 1.5 }} />

          <Box
            sx={{ display: "flex", justifyContent: "space-between", mb: 1.5 }}
          >
            <Typography
              sx={{
                fontSize: {
                  xs: "0.875rem !important",
                  sm: "0.9rem !important",
                  md: "1rem !important",
                },
                textAlign: "left",
                color: "#1A1A1A",
                fontWeight: "500 !important",
                mb: 1,
              }}
            >
              Total
            </Typography>
            <Typography
              sx={{
                fontSize: {
                  xs: "0.875rem !important",
                  sm: "0.9rem !important",
                  md: "1rem !important",
                },
                color: "#1A1A1A",
                fontWeight: "600 !important",
                mb: 1,
              }}
            >
             {taxInfo?.inclusive ? `S${cartFinalTotal.toFixed(2)}` : `S${finalTotal.toFixed(2)}`} 
            </Typography>
          </Box>

          {cartTotal > 0 &&
            cartTotal < taxInfo?.free_delivery &&
            preference === "delivery" && (
              <Typography
                variant="caption"
                color="#680000"
                sx={{
                  mb: 1.5,
                  display: "block",
                  textAlign: "center",
                  fontSize: {
                    xs: "0.75rem !important",
                    sm: "0.8rem !important",
                    md: "0.875rem !important",
                  },
                  fontWeight: "500 !important",
                }}
              >
                Add S${(taxInfo?.free_delivery - cartTotal).toFixed(2)} in Sub
                Total more for free delivery
              </Typography>
            )}
          {(selectedOutlet?.is_delivery_available || selectedOutlet?.is_takeaway_available) &&

            <FormControl sx={{ width: "100%" }}>
              <FormLabel
                id="demo-radio-buttons-group-label"
                sx={{
                  textAlign: "left",
                  fontSize: {
                    xs: "0.9rem !important",
                    sm: "1rem !important",
                    md: "1.1rem !important",
                  },
                  color: "#1A1A1A",
                  fontWeight: "600 !important",
                  mt: 1,
                  mb: 1,
                }}
              >
                Select Order Preference
              </FormLabel>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="delivery"
                name="radio-buttons-group"
                value={preference}
                onChange={(e) => setPreference(e.target.value)}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-evenly",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                {selectedOutlet?.is_delivery_available &&
                  <FormControlLabel
                    value="delivery"
                    control={
                      <Radio
                        sx={{
                          color: colors.primary.main,
                          "&.Mui-checked": {
                            color:colors.primary.main,
                          },
                          "& .MuiSvgIcon-root": {
                            fontSize: {
                              xs: "1.25rem !important",
                              sm: "1.5rem !important",
                              md: "1.75rem !important",
                            },
                          },
                        }}
                      />
                    }
                    label="Delivery"
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontSize: {
                          xs: "0.9rem !important",
                          sm: "1rem !important",
                          md: "1.1rem !important",
                        },
                        color: colors.primary.main,
                        fontWeight: "600 !important",
                      },
                      mb: 1,
                      mt: 1,
                    }}
                  />}

                {selectedOutlet?.is_takeaway_available &&
                  <FormControlLabel
                    value="takeaway"
                    control={
                      <Radio
                        sx={{
                          color:colors.primary.main,
                          "&.Mui-checked": {
                            color: colors.primary.main,
                          },
                          "& .MuiSvgIcon-root": {
                            fontSize: {
                              xs: "1.25rem !important",
                              sm: "1.5rem !important",
                              md: "1.75rem !important",
                            },
                          },
                        }}
                      />
                    }
                    label="Takeaway"
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontSize: {
                          xs: "0.9rem !important",
                          sm: "1rem !important",
                          md: "1.1rem !important",
                        },
                        color: colors.primary.main,
                        fontWeight: "600 !important",
                      },
                      mb: 1,
                      mt: 1,
                    }}
                  />
                }
              </RadioGroup>
            </FormControl>
          }

          <Button
            variant="contained"
            fullWidth
            startIcon={
              <ShoppingCart
                sx={{
                  fontSize: {
                    xs: "1.2rem !important",
                    sm: "1.4rem !important",
                    md: "1.5rem !important",
                  },
                }}
              />
            }
            onClick={() => {
              if (onCheckout) {
                // console.log("line 445");
                handleProccedToCheckout();
              } else {
                // console.log("line 448");
                if (sessionStorage.getItem('user')) {
                  handleProccedToCheckout();
                }
                else {
                  handleCheckout("guest-signup");
                }

              }
            }}
            disabled={loading}
            sx={{
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: "600 !important",
              fontSize: {
                xs: "0.875rem !important",
                sm: "0.9rem !important",
                md: "1rem !important",
              },
              py: { xs: 0.75, sm: 1 },
              mt: 2,
              backgroundColor: colors.primary.main,
              "&:hover": {
                bgcolor: colors.primary.main,
                color: "#FFF",
                border: `1px solid ${colors.primary.main}`,
              },
            }}
          >
            {loading ? "Processing..." : "Proceed to Checkout"}
          </Button>

          <Button
            variant="text"
            fullWidth
            onClick={clearCart && clearCart}
            sx={{
              textTransform: "none",
              fontSize: {
                xs: "0.875rem !important",
                sm: "0.9rem !important",
                md: "1rem !important",
              },
              py: 0.5,
              color: colors.primary.main,
              fontWeight: "600 !important",
              textDecoration: "underline !important",
              textUnderlineOffset: "4px !important",
              textDecorationThickness: "1.5px !important",
              "&:hover": {
                backgroundColor: "rgba(104, 0, 0, 0.04) !important",
                color: colors.primary.main,
                textDecoration: "underline !important",
              },
              mt: 2,
            }}
          >
            Clear Cart
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};

export default CartDrawer;
